import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  get isTutorialEnabled() {
    return false;
  }
}
